import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import * as Sentry from "@sentry/angular";
import {environment} from './environments/environment';
import packageJson from '../package.json';



Sentry.init({
  dsn: "https://da55d83b9eb9576b4be84d66a0a05128@sentry.megakit.pro/20",
  release: packageJson.version,
  tracesSampleRate: environment.production ? 0.1 : 1.0,
  environment: environment.production ? 'production' : 'development',
  sendDefaultPii: true
});

window.addEventListener('unhandledrejection', (event) => {
  Sentry.captureException(event.reason);
});

window.addEventListener('error', (event) => {
  Sentry.captureException(event.error ?? event.message);
});


bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
